import { render } from "./IpManagementModal.vue?vue&type=template&id=23855eae&scoped=true"
import script from "./IpManagementModal.vue?vue&type=script&lang=js"
export * from "./IpManagementModal.vue?vue&type=script&lang=js"

import "./IpManagementModal.vue?vue&type=style&index=0&id=23855eae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23855eae"]])

export default __exports__